import { MaskedLine } from "@/components/motion";
import { Reveal } from "@/components/motion";

export default function PageHero({ kicker, title, subtitle, image }) {
  return (
    <section className="relative border-b border-ink/10" data-testid="page-hero">
      <div className="relative flex min-h-[62vh] items-end overflow-hidden">
        {image && (
          <>
            <img src={image} alt={title} className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/20" />
          </>
        )}
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-14 pt-40 sm:px-6 lg:px-8">
          <p className="kicker kicker-light" data-testid="page-hero-kicker">{kicker}</p>
          <h1
            className="mt-6 max-w-4xl font-heading text-4xl font-semibold leading-[1.08] text-white sm:text-6xl"
            data-testid="page-hero-title"
          >
            <MaskedLine delay={0.1}>{title}</MaskedLine>
          </h1>
          {subtitle && (
            <Reveal delay={0.35}>
              <p
                className="mt-6 max-w-xl text-base leading-relaxed text-white/75 md:text-lg"
                data-testid="page-hero-subtitle"
              >
                {subtitle}
              </p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
